import DatetimePicker from '@/ui/components/Form/DatetimePicker';
import { dateFromDateStringWithAppendedTime } from '@/utils/dates';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Datepicker = ({
  autoFocus,
  dateFormat = 'M/d/yyyy',
  disabled,
  isClearable,
  label,
  minDate,
  name,
  onBlur,
  onChange,
  placement,
  preventOpenOnFocus,
  value, // Value is expected to be a date string in ISO format
  withPortal
}: Props) => {
  const handleChange = (value: Date | null) => {
    return value ? onChange(value.toISOString().split('T')[0]) : onChange(null);
  };

  return (
    <span>
      <DatetimePicker
        autoFocus={autoFocus}
        dateFormat={dateFormat}
        disabled={disabled}
        isClearable={isClearable}
        label={label}
        minDate={minDate}
        name={name}
        onBlur={onBlur}
        onChange={handleChange}
        placeholder="--/--/----"
        placement={placement}
        preventOpenOnFocus={preventOpenOnFocus}
        showTimeSelect={false}
        value={value}
        withPortal={withPortal}
      />

      <span className="text-xs text-gray-500">
        {value
          ? dateFromDateStringWithAppendedTime(value).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })
          : ''}
      </span>
    </span>
  );
};

export default Datepicker;
